module.exports = __webpack_public_path__ + "img/standardFGYL.75893d68.png";